import { render, staticRenderFns } from "./add-popup.vue?vue&type=template&id=1471f757&scoped=true&"
import script from "./add-popup.vue?vue&type=script&lang=js&"
export * from "./add-popup.vue?vue&type=script&lang=js&"
import style0 from "./add-popup.vue?vue&type=style&index=0&id=1471f757&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471f757",
  null
  
)

export default component.exports